<template>
  <v-container fluid class="evaluation-quiz">
    <v-row v-if="!isDone" align="center" justify="center" no-gutters>
      <v-col cols="12" class="text-center">
        <span
          >{{ questionsAnswered().length }} de
          {{ this.questions().length }} Preguntas</span
        >
      </v-col>
      <v-col class="text-center row" cols="12">
        <v-col cols="8" class="pt-6">
          <v-progress-linear
            :active="active"
            :background-opacity="opacity"
            :bottom="bottom"
            :buffer-value="buffer"
            :height="height"
            :indeterminate="indeterminate"
            :query="query"
            :rounded="rounded"
            :stream="stream"
            :striped="striped"
            :top="top"
            :value="ProgressValue"
            color="accent"
          ></v-progress-linear>
        </v-col>
        <v-col class="align-center" cols="3">
          <v-btn
            class="text-center text-capitalize"
            outlined
            rounded
            @click="doneQuiz"
            color="accent"
            >Terminar</v-btn
          >
        </v-col>
      </v-col>
    </v-row>
    <div id="scroll-container-question" class="mt-3" v-if="!isDone">
      <v-row
        class="container-question"
        v-for="(item, i) in this.questions()"
        :key="i + 1"
        align="center"
        :class="answeredContainer(i + 1)"
        no-gutters
      >
        <v-col cols="2">
          <span class="btn-question" :class="answeredBtn(i + 1)">
            {{ i + 1 }}
          </span>
        </v-col>
        <v-col cols="2" v-for="(items, x) in item.alternativesNumber" :key="x">
          <button
            class="answer"
            :class="answeredOption(i + 1, getPosition(x))"
            @click="e => answer(e, i + 1, getPosition(x))"
          >
            {{ getPosition(x) }}
          </button>
        </v-col>
      </v-row>
    </div>
    <div v-else>
      <v-row align="center">
        <v-col cols="12" class="text-center">
          <span class="text-h6">Evaluación Terminada</span>
        </v-col>
      </v-row>
    </div>
  </v-container>
</template>
<script>
import { mapActions, mapGetters } from "vuex";

export default {
  name: "RomaBarLateralPoll",
  data: () => ({
    absolute: true,
    active: true,
    opacity: 0,
    bottom: false,
    buffer: 100,
    fixed: false,
    height: 10,
    indeterminate: false,
    query: false,
    rounded: true,
    stream: false,
    striped: false,
    top: false,
    ProgressValue: 0,
    isDone: false,
    changeOption: false
  }),
  mounted() {
    // console.log(this.questions());
    this.ProgressValue = (100 * this.questionsAnswered().length) / this.questions().length;
    /*
    if (this.questions.length === 0) {
      for (let index = 0; index < this.totalQuestion; index++) {
        this.questions.push(index + 1);
      }
    }
    */
  },

  methods: {
    ...mapGetters({
      totalQuestion: "getquantityQuestions",
      questionAndAnswers: "getQuestionsAndAnswers",
      questionsAnswered: "getQuestionsAnswered",
      questions: "getQuestions",
      evaluationDetails: "getEvaluationDetail"
    }),
    ...mapActions({
      toastSuccess: "toastSuccess",
      toastError: "toastError",
      setQuestionAndAnswers: "setQuestionAndAnswers",
      setQuestionsAnswered: "setQuestionsAnswered",
      saveQuiz: "saveQuiz"
    }),
    async doneQuiz() {
      if (this.questionsAnswered().length < this.questions().length) {
        const reduce = this.questions().length - this.questionsAnswered().length;
        this.toastError({
          title: "Información",
          message: `¡Debes completar la encuesta! Te faltan ${reduce} preguntas por responder`
        });
      } else {
        const { form, idSeccion, idMatricula } = this.evaluationDetails();
        const answers = {
          idMedicionAsignada: 162569,
          answerQuestionList: this.questionAndAnswers(),
          idSeccion,
          idMatricula,
          idForma: form.idForma
        };
        await this.saveQuiz(answers);
        this.isDone = true;
      }
    },
    answer(e, item, option) {
      e.target.classList.toggle("active");
      const question = this.questionAndAnswers().find(
        (answer) => answer.questionNumber === item
      );
      const questionAnswered = this.questionsAnswered().find(
        (answer) => answer === item
      );
      if (typeof question !== "undefined") {
        for (const qn of this.questionAndAnswers()) {
          if (qn.questionNumber === item) {
            if (qn.answerLetter === option) {
              // Remove option
              const i = this.questionAndAnswers()
                .map((e) => e.questionNumber)
                .indexOf(item);
              this.questionAndAnswers().splice(i, 1);
              const op = this.questionsAnswered().indexOf(item);
              this.questionsAnswered().splice(op, 1);
              if (this.changeOption) {
                // Remove and add
                this.questionsAnswered().push(item);
                this.questionAndAnswers().push({
                  questionNumber: item,
                  answerLetter: option,
                });
                this.changeOption = false;
              }
            } else {
              // Change
              const i = this.questionAndAnswers()
                .map((e) => e.questionNumber)
                .indexOf(item);
              this.questionAndAnswers().splice(i, 1);
              const op = this.questionsAnswered().indexOf(item);
              this.questionsAnswered().splice(op, 1);
              this.questionsAnswered().push(item);
              this.questionAndAnswers().push({
                questionNumber: item,
                answerLetter: option,
              });
              this.changeOption = true;
            }
          }
        }
      } else {
        // Add
        this.questionsAnswered().push(item);
        this.questionAndAnswers().push({
          questionNumber: item,
          answerLetter: option,
        });
      }
      this.ProgressValue =
        (100 * this.questionsAnswered().length) / this.questions().length;
      this.setQuestionsAnswered(this.questionsAnswered());
      this.setQuestionAndAnswers(this.questionAndAnswers());
    },
    answeredContainer(id) {
      const question = this.questionsAnswered().find((answer) => answer === id);
      return [id === question ? "answered" : ""];
    },
    answeredBtn(id) {
      const question = this.questionsAnswered().find((answer) => answer === id);
      return [id === question ? "btn-answered" : ""];
    },

    answeredOption(id, option) {
      const question = this.questionAndAnswers().find(
        (answer) =>
          answer.answerLetter === option && answer.questionNumber === id
      );
      const op = typeof question !== "undefined" ? question.answerLetter : null;
      return [option === op ? "active" : "answer"];
    },

    getPosition(x) {
      const array = [
        "A",
        "B",
        "C",
        "D",
        "E",
        "F",
        "G",
        "H",
        "I",
        "J",
        "K",
        "L"
      ];
      return array[x];
    },
  },
};
</script>

<style lang="scss">
.evaluation-quiz {
  max-height: 100vh;

  .done {
    height: 80vh;
  }
  .v-progress-linear__buffer {
    background: #d9d9d9 !important;
  }
  .v-application .accent {
    background-color: #f39444 !important;
    border-color: #f39444 !important;
    border-radius: 15px !important;
    z-index: 10 !important;
  }

  #scroll-container-question {
    width: 100%;
    padding: 0 10px 10px 10px;
    overflow-y: scroll;
    height: 80vh;
  }

  #scroll-container-question {
    scrollbar-width: thin;
    scrollbar-color: blue orange;
  }

  #scroll-container-question::-webkit-scrollbar {
    width: 5px;
  }
  #scroll-container-question::-webkit-scrollbar-track {
    background: #d9d9d9;
    border-radius: 25px;
  }
  #scroll-container-question::-webkit-scrollbar-thumb {
    background-color: #e97c21;
    border-radius: 25px;
  }

  .container-question {
    background: #ffffff 0 0 no-repeat padding-box;
    border: 1px solid #c4c4c4;
    border-radius: 8px;
    opacity: 1;
    margin-bottom: 15px;
    height: auto;
  }

  .answered {
    border: 1px solid #3a8fce !important;
  }

  .btn-question {
    width: 45px;
    height: 44px;
    max-width: 45px;
    border-radius: 5px 0 0 5px;
    font-size: 24px;
    font-weight: bold;
    opacity: 1;
    border-right: 1px solid #d7d7d7;
    margin-right: 20px;
  }

  .btn-answered {
    background: #3a8fce 0 0 no-repeat padding-box !important;
    color: #ffffff !important;
  }

  .answer {
    width: 36px;
    height: 36px;
    background: #ffffff 0 0 no-repeat padding-box;
    border: 1px solid #c1c1c1;
    border-radius: 5px;
    opacity: 1;
    margin: 4px 0;
  }

  .active {
    background: #f39444 0 0 no-repeat padding-box;
    color: #ffffff;
  }
}
</style>
